// extracted by mini-css-extract-plugin
export default {"wrapper":"Discord_wrapper__4YIza","body_wrapper":"Discord_body_wrapper__3EaJl","group_wrapper":"Discord_group_wrapper__BTgds","discord_icon":"Discord_discord_icon__zLO3Q"};